<div style="height: 100%" data-cy="erx-patient-data-container">
    <div class="section-header" data-cy="erx-patient-data-header">
      <div class="section-header-title" data-cy="erx-patient-data-title">eRX Patient Validation</div>
    </div>
    <table align="center" border="0" cellpadding="1" cellspacing="1" style="width:100%" data-cy="erx-patient-data-table">
        <tbody>
            <tr data-cy="erx-patient-data-header-row">
                <td style="background-color:#ff3333" data-cy="erx-patient-data-issues-header">Patient Validation Issues</td>
                <td style="background-color:#009900" data-cy="erx-patient-data-pass-header">Patient Validation Pass</td>
            </tr>
            <tr data-cy="erx-patient-data-firstname-row">
                <td style="width:251px" data-cy="erx-patient-data-firstname-error">
                <p>{{firstNameErr}}</p>
                </td>
                <td style="width:235px" data-cy="erx-patient-data-firstname-value"><p>{{firstName}}</p></td>
            </tr>
            <tr data-cy="erx-patient-data-lastname-row">
                <td style="width:251px" data-cy="erx-patient-data-lastname-error">
                    <p>{{lastNameErr}}</p>
                    </td>
                    <td style="width:235px" data-cy="erx-patient-data-lastname-value"><p>{{lastName}}</p></td>
            </tr>
            <tr data-cy="erx-patient-data-address-row">
                <td style="width:251px" data-cy="erx-patient-data-address-error">
                    <p>{{addressErr}}</p>
                    </td>
                    <td style="width:235px" data-cy="erx-patient-data-address-value"><p>{{address}}</p></td>
            </tr>
            <tr data-cy="erx-patient-data-city-row">
                <td style="width:251px" data-cy="erx-patient-data-city-error">
                    <p>{{cityErr}}</p>
                    </td>
                    <td style="width:235px" data-cy="erx-patient-data-city-value"><p>{{city}}</p></td>
            </tr>
            <tr data-cy="erx-patient-data-zip-row">
                <td style="width:251px" data-cy="erx-patient-data-zip-error">
                    <p>{{zipErr}}</p>
                    </td>
                    <td style="width:235px" data-cy="erx-patient-data-zip-value"><p>{{zip}}</p></td>
            </tr>
            <tr data-cy="erx-patient-data-state-row">
                <td style="width:251px" data-cy="erx-patient-data-state-error">
                    <p>{{stateErr}}</p>
                    </td>
                    <td style="width:235px" data-cy="erx-patient-data-state-value"><p>{{state}}</p></td>
            </tr>
            <tr data-cy="erx-patient-data-birth-row">
                <td style="width:251px" data-cy="erx-patient-data-birth-error">
                    <p>{{birthErr}}</p>
                    </td>
                    <td style="width:235px" data-cy="erx-patient-data-birth-value"><p>{{birth}}</p></td>
            </tr>
            <tr data-cy="erx-patient-data-phone-row">
                <td style="width:251px" data-cy="erx-patient-data-phone-error">
                    <p>{{phoneErr}}</p>
                    </td>
                    <td style="width:235px" data-cy="erx-patient-data-phone-value"><p>{{phone}}</p></td>
            </tr>
            <tr data-cy="erx-patient-data-connection-row">
                
                <td style="background-color:#858ffa" colspan="2" data-cy="erx-patient-data-connection-header">Connection Errors with eRX Service</td>
            
            </tr>
            <tr data-cy="erx-patient-data-additional-row">
                
                <td style="width:251px" colspan="2" data-cy="erx-patient-data-additional-error">
                    <p>{{additionalErr}}</p>
                    </td>
               
            </tr>
        </tbody>
    </table>
    <div mat-dialog-actions data-cy="erx-patient-data-actions">
        <button style="align-content:centery;" mat-button (click)="onCloseClick()" data-cy="erx-patient-data-close-button">Close</button>
    </div>
  </div>